var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechInternship(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.175,
    height: 142.167,
    viewBox: "0 0 142.175 142.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 111.844,
    height: 111.856,
    fill: "#3734a9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flech-internship",
    transform: "matrix(0.326, 0.946, -0.946, 0.326, 105.762, 0)",
    opacity: 0.118
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_291",
    "data-name": "Groupe 291",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_362",
    "data-name": "Trac\\xE9 362",
    d: "M110.621,94.693q-7.907,7.976-15.883,15.884a3.878,3.878,0,0,1-5.778-.025q-7.923-7.873-15.8-15.795a3.984,3.984,0,1,1,5.662-5.6c2.7,2.656,5.362,5.344,8.036,8.024.277.277.517.59.955,1.095.265-9.832-.229-19.211-2.639-28.42C83.115,61.984,80,54.627,74.745,48.305a32.854,32.854,0,0,0-7.4-6.681c.14,1.6.31,3.043.388,4.491.715,13.356-9.643,23.246-22.565,21.562a20,20,0,0,1-17.2-18.817c-.328-10.044,6.021-18.182,15.7-20.185A34.8,34.8,0,0,1,52,28.184a43.713,43.713,0,0,0-8.51-7.889C31.772,11.948,18.6,8.194,4.321,7.983,1.765,7.945,0,6.308,0,3.985A4.018,4.018,0,0,1,4.335,0a76.708,76.708,0,0,1,36.7,9.208c9.142,5,16.779,11.624,21.962,20.812a2.286,2.286,0,0,0,1.372.958A40.738,40.738,0,0,1,81.679,44.017c6.222,7.9,9.751,17,11.929,26.7a106.162,106.162,0,0,1,2.249,25.278c-.011.647,0,1.295,0,2.306.5-.549.754-.856,1.036-1.138,2.674-2.68,5.336-5.37,8.033-8.026a3.98,3.98,0,1,1,5.7,5.557M59.831,45.832a28.618,28.618,0,0,0-1.878-7.842,1.421,1.421,0,0,0-1.094-1.016,36.563,36.563,0,0,0-7.308-.98c-3.217.063-6.343.585-9.058,2.532a11.407,11.407,0,0,0-4.224,12.09c1.236,4.853,4.359,8.026,9.289,9.008,8.434,1.679,15.085-4.834,14.274-13.791",
    transform: "translate(0 0)",
    fill: "#3734a9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechInternship);
export default __webpack_public_path__ + "static/media/flech-internship.d4791d3e77d21237174129e86e4ad92c.svg";
export { ForwardRef as ReactComponent };